import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=67eff646&scoped=true&"
import script from "./FormTitle.vue?vue&type=script&lang=js&"
export * from "./FormTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eff646",
  null
  
)

export default component.exports